import React from 'react'

import { MobileApproveContent } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'

export const MobileApproveWrapper: React.FC = () => {
  const { activeScreen, hostServices, logger } = useTransmit()
  const { initTime } = activeScreen.payload

  /**
   * Below is a best attempt to indicate to Transmit the user has abandoned
   * the mobile approve session.
   */
  React.useEffect(() => {
    hostServices?.globalnav.setIsHidden(true)

    const onPopState = (_event: PopStateEvent): void => {
      const {
        type,
        payload: { handleAbandon },
      } = activeScreen

      if (type === 'MobileApprove' && handleAbandon) {
        handleAbandon()
      }
    }

    window.addEventListener('popstate', onPopState)

    return (): void => {
      hostServices?.globalnav.setIsHidden(false)

      // If this isn't behind a setTimeout it will remove the event listener before its triggered
      setTimeout(() => {
        window.removeEventListener('popstate', onPopState)
      }, 0)
    }
  }, [initTime])

  if (activeScreen.type !== 'MobileApprove') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return (
    <MobileApproveContent
      {...activeScreen.payload}
      hostServices={hostServices}
      logger={logger}
    />
  )
}
